import { createElement, type ComponentProps } from 'react'

import type ScreenLayout from '@/components/layout/ScreenLayout'
import SignalsRail from '@/screens/signals/components/SignalsRail'

type SignalsRailLayoutProps = Pick<
  ComponentProps<typeof ScreenLayout>,
  'pageTitle' | 'rail' | 'railLabel'
>

/**
 * `ScreenLayout`'s rail props for a Signal Zone page, spread in place of
 * `pageTitle`: `<ScreenLayout header={HEADER} {...signalsRailProps(TITLE)}>`.
 * The title still goes to `ScreenLayout`, for the Ask Mitra bar's page chip.
 * Pending, loaded and locked pages alike, so the rail carries on through a
 * pending page's handoff instead of swapping cards when the page lands.
 *
 * The label is the shared rail's own landmark name, since this one stands in
 * for it, so the landmark reads the same on every page.
 */
export const signalsRailProps = (pageTitle: string): SignalsRailLayoutProps => ({
  pageTitle,
  rail: createElement(SignalsRail),
  railLabel: 'Market rail',
})
